export default __webpack_public_path__ + "static/media/EG.e92bc157.svg";